"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * Maps field type IDs from Sitecore (/sitecore/system/Settings/Forms/Field Types)
 * into an implementing React component - this is very similar to the JSS componentFactory,
 * but it maps form element components instead of layout components
 */
var FieldFactory = /** @class */ (function () {
    function FieldFactory() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._fieldMap = new Map();
        // eslint-disable-next-line react/display-name
        this._defaultComponent = function (props) { return (react_1.default.createElement("div", { key: props.model.fieldTypeItemId },
            props.model.name,
            ": No renderer for form element type ",
            props.model.fieldTypeItemId)); };
    }
    FieldFactory.prototype.setComponentNotFoundComponent = function (component) {
        this._defaultComponent = component;
    };
    FieldFactory.prototype.setComponent = function (type, component) {
        this._fieldMap.set(type, component);
    };
    FieldFactory.prototype.get = function (field, props) {
        var Result = this._fieldMap.get(field.model.fieldTypeItemId);
        if (!Result) {
            var Default = this._defaultComponent;
            return react_1.default.createElement(Default, __assign({}, field));
        }
        return react_1.default.createElement(Result, __assign({}, props));
    };
    return FieldFactory;
}());
exports.default = FieldFactory;
